import { Box, Chip, Typography, useTheme } from "@mui/material";
import FlexWrapper from "shared-component/flex-wrapper";

export const FillToolTipContent = () => {
    return (
        <div style={{ textAlign: "left" }}>
            <Typography fontWeight={"bold"}>Fill Job</Typography>
            <Typography fontWeight={'normal'}>
                Please Select applicable Signals and Fill type.
            </Typography>
        </div>

    )
}

export const AggregateToolTipContent = () => {
    return (
        <div>
            <Typography fontWeight={"bold"}>Aggregate Job</Typography>
            <Typography fontWeight={'normal'}>
                Please Select applicable Signals, Group By and Aggregate type.
            </Typography>
        </div>

    )
}


export const JobStatusFillToolTipContent = () => {
    return (
        <div style={{ textAlign: "left" }}>
            <Box pt={1}>
                <FlexWrapper justifyContent pb={1}>
                    <Chip
                        label="Submitted"
                        variant="outlined"
                        color="warning"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                    <Typography variant="body2">
                        The job request is currently submitted and will be processed. Please check back in 5 - 10 mins and
                        click on refresh button.
                    </Typography>
                </FlexWrapper>
                <FlexWrapper justifyContent pb={1}>
                    <Chip
                        label="In Progress"
                        variant="outlined"
                        color="warning"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                    <Typography variant="body2">
                        The data is being unnested. Please check back in 5 - 10 mins and
                        click on refresh button.
                    </Typography>
                </FlexWrapper>
                <FlexWrapper justifyContent pb={1}>
                    <Chip
                        label="Success"
                        variant="outlined"
                        color="success"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                    <Typography variant="body2">
                        The data has been unnested. Please click on the job to see the
                        details.
                    </Typography>
                </FlexWrapper>
                <FlexWrapper justifyContent pb={1}>
                    <Chip
                        label="Error"
                        variant="outlined"
                        color="error"
                        size="small"
                        sx={{ marginRight: 1, fontWeight: "bold" }}
                    />
                    <Typography variant="body2">
                        The request was errored out. Find out the reason by hovering the
                        cursor on the status.
                    </Typography>
                </FlexWrapper>
            </Box>
        </div>

    )
}


export const WelcomeToolTipContent = () => {
    const theme = useTheme();
    return (
           <Box flex={1}>
              <Typography
                pt={1}
                color={theme.palette.text.primary}
                sx={{ fontSize: "medium", width: "96%"}}
              >
                {"Welcome to the C-DAD (Connected Vehicle- Data Analytics Dashboard) , developed by the VEADS team and DS. The goal of this tool is to allow users to interact with CAN data without requiring a technical coding skillset. All data in the tool is represented at a VIN level and thus is good starting point for root cause investigations, however is not a comprehensive tool."}
              </Typography>
            </Box>
    )
}